var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"submission-error-page"},[_vm._v(" Opps We have an error "),_c('router-link',{attrs:{"to":'/'}},[_vm._v(" Test ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }